import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetSubAdminByIdQuery } from "../../service/subAdmin";
import { showError } from "../../constants/toasts";
import moment from "moment";

const SubadminDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getById] = useLazyGetSubAdminByIdQuery();
  const [data, setData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    const fetch = async () => {
      if (!id) {
        navigate("/manage-subadmin");
        return;
      }
      try {
        setLoading(true);
        const res = await getById({ id }).unwrap();
        if (res?.code === 200) {
          setData(res?.data);
        } else {
          showError(res?.message || "Failed to fetch sub-admin");
          navigate("/manage-subadmin");
        }
      } catch (error: any) {
        console.error("Error fetching sub-admin:", error);
        showError(error?.data?.message || "Failed to fetch sub-admin");
        navigate("/manage-subadmin");
      } finally {
        setLoading(false);
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fullPhone =
    data?.countryCode && data?.phone
      ? `${data.countryCode}${data.phone}`
      : data?.phone || "";
  const roleLabel = data?.accessRole?.name || "N/A";
  const created = data?.createdAt ? moment(data.createdAt).format("lll") : "";

  return (
    <>
      <div className="main_title">
        <h1>Sub-Admin Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-subadmin")}>
            Manage Sub-Admin
          </button>{" "}
          - Sub-Admin Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img
                alt="user"
                src={data?.image || "/static/images/user_placeholder.png"}
              />
            </figure>
          </div>
          <div className="w_33">
            <h6>First Name</h6>
            <p>{data?.firstName || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Last Name</h6>
            <p>{data?.lastName || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Email Address</h6>
            <p>{data?.email || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{fullPhone || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>{roleLabel}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{created || "-"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubadminDetail;
